module.exports = __webpack_public_path__ + "img/rose-bowl_1.38b6adfd.jpg";